import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import ConfirmDeleteModal from './ConfirmationModelDelete';

// Sample static data
const staticData = [
  {
    id: 1,
    image: 'https://via.placeholder.com/50',
    name: 'Category 1',
    createdAt: '2024-08-01T12:00:00Z',
  },
  {
    id: 2,
    image: 'https://via.placeholder.com/50',
    name: 'Category 2',
    createdAt: '2024-08-02T14:30:00Z',
  },
  // Add more static data as needed
];

const ListProductSubCategory = () => {
  const [userData, setUserData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const history = useHistory();

  // Use static data instead of fetching from API
  useEffect(() => {
    setUserData(staticData);
  }, []);

  const handleEdit = (e, id) => {
    history.push(`/edit-product-sub-category/${id}`);
  };

  const handleDelete = (id) => {
    // Simulate delete action
    setUserData(userData.filter(user => user.id !== id));
    setShowModal(false);
  };

  const handleDeleteClick = (id) => {
    setSelectedUserId(id);
    setShowModal(true);
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>List Product Sub Category</h2>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead style={{ textAlign: "center", whiteSpace: "nowrap" }}>
              <tr>
                <th>#</th>
                <th>Image</th>
                <th>Name</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody style={{ textAlign: "center" }}>
              {userData.map((user, index) => (
                <tr key={user.id}>
                  <td>{index + 1}</td>
                  <td>
                    {user.image && (
                      <img 
                        src={user.image} 
                        alt="image" 
                        style={{ width: "50px", height: "50px", borderRadius: "50%" }} 
                      />
                    )}
                  </td>
                  <td>{user.name}</td>
                  <td>{formatDate(user.createdAt)}</td>
                  <td>
                    <i className="icon-pencil" onClick={(e) => handleEdit(e, user.id)}></i>
                    &nbsp;&nbsp;
                    <i className="fa fa-trash-o" onClick={() => handleDeleteClick(user.id)}></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <ConfirmDeleteModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          handleConfirm={() => handleDelete(selectedUserId)}
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(ListProductSubCategory);
